import { CalendarIcon, ZapIcon, TargetIcon, GamepadIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface Bonus {
  icon: LucideIcon;
  emoji: string;
  title: string;
  value: string;
  text: string;
}

export const bonuses: Bonus[] = [
  {
    icon: CalendarIcon,
    emoji: '🗓️',
    title: 'Plan de Arranque 7 Días',
    value: '9,90€',
    text: 'La hoja de ruta exacta para aplicar VOLEY-PRO 360 desde el primer día sin perderte entre 350 páginas. Diagnóstico del equipo, sistema de juego, primera sesión lista y primer mensaje a padres en solo 7 días.'
  },
  {
    icon: ZapIcon,
    emoji: '⚡',
    title: 'Sesión Express 15 Minutos',
    value: '12,90€',
    text: 'Tu botón de emergencia como entrenador. Cuando salgas tarde del trabajo y todavía no hayas preparado el entrenamiento del martes, abres este bono y en 15 minutos tienes una sesión profesional lista. Incluye 20 condiciones de partido listas para usar.'
  },
  {
    icon: TargetIcon,
    emoji: '🎯',
    title: '30 Entrenamientos Listos para Pitar',
    value: '14,90€',
    text: 'Sesiones completas listas organizadas por objetivo: técnica individual, táctica K1-K2, físico con balón, remate y balón parado. Cada una con tiempos exactos, correcciones clave y adaptación para pocos jugadores o pista pequeña. El recurso más consultado por los entrenadores que ya tienen el sistema.'
  },
  {
    icon: GamepadIcon,
    emoji: '🏐',
    title: '30 Juegos Técnicos para Base',
    value: '11,90€',
    text: '30 juegos competitivos para mejorar dedos, antebrazo, coordinación, remate sin que parezca un ejercicio aburrido. Cuando hay algo en juego, la intensidad y el aprendizaje se multiplican. Adaptados desde Alevín hasta Juvenil.'
  },
  {
    icon: SmartphoneIcon,
    emoji: '📱',
    title: 'Mapa de Temporada en una Página',
    value: '9,90€',
    text: 'Una sola hoja con toda la temporada planificada. Qué foco trabajar cada mes, qué tomo consultar y cómo medir si el equipo ha mejorado. Imprimible y plastificable para llevar siempre en tu carpeta.'
  }
];
